import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserCard from "./UserCard";
import Slider from "react-slick";
import { toast } from "react-toastify";
import { URL } from "../../../Redux/common/url";
import Boxes3 from "./Boxes3";

function Deshboard1() {
  const navigate = useNavigate();
  const deshboard = useSelector((state) =>
    state?.allapi?.deshboard ? state?.allapi?.deshboard : {}
  );
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const slider = useSelector((state) =>
    state?.allapi?.slider_list ? state?.allapi?.slider_list : {}
  );
  const slideData = slider?.sliders ? slider?.sliders : [];

  let pageUrl =
    "https://manglamart.com/referalsignup?ref=" +
    get_profile?.referId;

  function copyAndShare() {
    const el = document.createElement("input");
    el.value = pageUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    toast.success("Your Referral link Copied!");

    // WhatsApp share
    const whatsappUrl =
      "https://wa.me/?text=" + encodeURIComponent(pageUrl);
    window.open(whatsappUrl, "_blank");
  }

  /* OLD: Left/Right club buttons - COMMENTED OUT
  function copy() {
    const el = document.createElement("input");
    el.value = pageUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Your Referal link Copied!");

    // setstshareshow(false);
  }
  function copy2() {
    const el = document.createElement("input");
    el.value = pageUrl2;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Your Referal link Copied!");

    // setstshareshow(false);
  }

  const shareOnWhatsApp = (link) => {
    const whatsappUrl =
      "https://wa.me/?text=" + encodeURIComponent(link);
    window.open(whatsappUrl, "_blank");
  };
  */

  return (
    <div className="container-fluid p-0 overflow-hidden">
      <div className="row g-3">

        {/* USER CARD – 40% */}
        <div className="col-12 col-xl-4">
          <UserCard />

          <div className="d-flex flex-wrap my-3 justify-content-between ">
            {/* OLD: Left/Right club buttons - COMMENTED OUT
            <button
              onClick={copy}
              style={{
                padding: "6px 8px",
                borderRadius: "20px",
                border: "1px solid #d4af37",
                background: "linear-gradient(135deg, #0b3d2e, #145a32)",
                color: "#f5d76e",
                fontSize: "11px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              <i class="bi bi-share" style={{marginRight:"5px"}}></i> Refer for Left Club 
            </button>

            <button
              onClick={copy2}
              style={{
                padding: "6px 8px",
                borderRadius: "20px",
                border: "1px solid #d4af37",
                background: "linear-gradient(135deg, #0b3d2e, #145a32)",
                color: "#f5d76e",
                fontSize: "11px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Refer for Right Club<i class="bi bi-share" style={{marginLeft:"5px"}}></i> 
            </button>
            */}

            {/* OLD LEFT/RIGHT BUTTONS WITH WHATSAPP - COMMENTED OUT
            <button
              onClick={() => {
                copy(pageUrl);
                shareOnWhatsApp(pageUrl);
              }}
              style={{
                padding: "6px 8px",
                borderRadius: "20px",
                border: "1px solid #d4af37",
                background: "linear-gradient(135deg, #0b3d2e, #145a32)",
                color: "#f5d76e",
                fontSize: "11px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              <i className="bi bi-share" style={{ marginRight: "5px" }}></i>
              Refer for Left Club
            </button>

            <button
              onClick={() => {
                copy2(pageUrl2);
                shareOnWhatsApp(pageUrl2);
              }}
              style={{
                padding: "6px 8px",
                borderRadius: "20px",
                border: "1px solid #d4af37",
                background: "linear-gradient(135deg, #0b3d2e, #145a32)",
                color: "#f5d76e",
                fontSize: "11px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Refer for Right Club
              <i className="bi bi-share" style={{ marginLeft: "5px" }}></i>
            </button>
            */}

            {/* NEW: Single Share button */}
            <button
              onClick={copyAndShare}
              style={{
                padding: "6px 8px",
                borderRadius: "20px",
                border: "1px solid #d4af37",
                background: "linear-gradient(135deg, #0b3d2e, #145a32)",
                color: "#f5d76e",
                fontSize: "11px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              <i className="bi bi-share" style={{ marginRight: "5px" }}></i>
              Share Referral Link
            </button>

          </div>
        </div>

        {/* SLIDER – 60% */}
        <div className="col-12 col-xl-8">
          <div className="slider-wrapper">
            <Slider {...settings}>
              {slideData?.map((data, i) => (
                <div key={i}>
                  <img
                    src={URL.API_BASE_URL + data.image}
                    alt={`slider-${i}`}
                    className="img-fluid w-100"
                    style={{
                      maxHeight: "340px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* BOXES – FULL WIDTH */}
        <div className="col-12">
          <Boxes3 />
        </div>


        <div className="w-100 d-flex justify-content-center md-mt-30 mt-50">
          <img
            src="/img/loginpages.png"
            className="img-fluid login-img"
            alt="login"
          />
        </div>

      </div>
    </div>


  );
}

export default Deshboard1;